// extracted by mini-css-extract-plugin
module.exports = {"block":"styles_block__1_dMY","moveSlideshow":"styles_moveSlideshow__1igEM","imageWrapper":"styles_imageWrapper__1tGXs"};